import { useEffect } from 'react';

/**
 * Loads GA4 only if VITE_ANALYTICS_ID is set. Safe no-op otherwise.
 */
export default function Analytics() {
  const gaId = import.meta.env.VITE_ANALYTICS_ID as string | undefined;

  useEffect(() => {
    if (!gaId) return;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script.async = true;
    document.head.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
    document.head.appendChild(inlineScript);

    return () => {
      script.remove();
      inlineScript.remove();
    };
  }, [gaId]);

  return null;
}
